import { observable, makeObservable } from "mobx";

export default class AnnotationsStore {
  data = {};

  constructor() {
    makeObservable(this, {
      data: observable,
    });
  }
}
